import React from 'react';
import { StickyNote } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useDailyNotes } from '@/hooks/useDailyNotes';

interface NotesButtonProps {
  date: Date;
  onOpenNotes: () => void;
}

const NotesButton = ({ date, onOpenNotes }: NotesButtonProps) => {
  const { t } = useTranslation();
  const { note } = useDailyNotes(date);

  const hasNotes = note?.content && note.content.trim().length > 0;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onOpenNotes}
      className={hasNotes ? 'border-primary bg-primary/5' : ''}
    >
      <StickyNote className={`h-4 w-4 mr-2 ${hasNotes ? 'text-primary' : ''}`} />
      {t('calendar.dayNotes')}
    </Button>
  );
};

export default NotesButton;